import React, { Component } from 'react'
//import ReactDOM from "react-dom";
import 'jquery/dist/jquery.min.js';
import ls from 'local-storage'

//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery'; 


export default class Workproposelist extends Component {
  constructor(props){
    super(props);   
    this.state = {
      worklist: []
    } 
    this.selectmultihandleChange = this.selectmultihandleChange.bind(this);        
  }   
  componentDidMount(){
    document.title = "Works Propose List"
    const loginToken = ls.get('loginToken');
    this.$el =$(this.el);
    this.$el.DataTable({
        "scrollY":        "500px",
        "scrollX":        true,
        "scrollCollapse": true,	   
        "aLengthMenu": [
            [10,25, 50, 100, -1],
            [10,25, 50, 100, "All"]
        ],		
        "processing": true,
        'language': {
            'loadingRecords': '&nbsp;',
            'processing': '<div class="spinner_datatable"></div>'
        },
        "serverSide": true,
        "ajax": {
                    url : `${process.env.REACT_APP_API_URL}works/getworksproposallist`,
                    type: "POST",          
                    headers: { 'Authorization': 'bearer '+loginToken } 
        },
	
        "columnDefs": [ {
            "searchable": false,
            "orderable": false,
            "targets":[0,1,9]
        },{
          targets: 9,
          className: 'text-ceter'
      },{
        targets: 0,
        className: 'text-ceter'
    }],
        "order": [[ 9, 'ASC' ]],
        "createdRow": function(row, data, index) {
          if(data['status'] === 3)
            $(row).addClass("success");
          else if(data['status'] === 1)
            $(row).addClass("warning");
          else if(data['status'] === 2)
            $(row).addClass("danger");
          else
            $(row).addClass("gradeA");
         },        
        "columns": [
            {
                title: "<input type='checkbox'  name='selectall' class='selectall'>",
                data:"checkbox"       
              },
            {
              title: "Sr No",
              data:"sr_no",
              type: 'text',
            }, {
              title: "Work Head",
              data:"workhead"
            }, {
              title: "Work Name",
              data:"workname"
            }, {
              title: "Work Category",
              data:"worktypename"
            }, {
              title: "Scheme",
              data:"schemename"
            }, {
              title: "Controlling Office",
              data:"officename"
            }, {
              title: "Reject Reason",
              data:"reject_reason"
            }, {
              title: "Actual Workhead",
              data:"actual_workhead"
            },  {
              title: "Edit",
              data:"editable"
            }
        ]
    }
    )
}
async selectmultihandleChange(e) {       
  let worklist = this.state.worklist;
  worklist =  Array.isArray(e) ? e.map(x => x.target.value) : []; 
  this.setState({worklist}); 
}
componentWillUnmount() {
      this.$el =$(this.el);
      this.$el.DataTable().destroy(true);
}   
    
    render() {           
        return (
          <div className="content-wrapper">
        <section className="content-header">
          <h1>
           Work Propose Master
          </h1>
          <ol className="breadcrumb">
            <li><i className="fa fa-dashboard"></i> Home</li>
            <li className="active">Work Master</li>
          </ol>
        </section>
        <section className="content">
          <div className="box">
              <div className="box-body">	             
                <div className="col-md-12">
                <table className="table table-hover table-bordered" width="100%" ref={el => this.el =el}></table>  
                     </div>
                </div>
          </div>
        </section>
        
        </div> 
        )
    }
}